<script lang="ts">
  import { dayjs } from '../../lib/dayjs';
  import { onDestroy, onMount } from 'svelte';
  import RejectionReasonModal from '../_shared/RejectionReasonModal.svelte';
  import AiVerificationModal from '../_shared/AiVerificationModal.svelte';
  import EventQueue from '../../lib/custom-event';
  import { debugLog } from '../../lib/debug-log';
  import { getAuthHeaders } from '../../lib/authHeaders';
  import {
    getStandardFieldTransformations,
    CRITERIA_STATUS_FIELDS,
    CRITERIA_HIDDEN_FIELDS,
    ALL_CRITERIA_FIELDS,
    CRITERIA_DROPDOWN_FIELDS,
  } from '../../lib/agentTransformations';

  let URL = `${process.env.SVELTE_APP_REMOTE_URL}/api`;

  const mountAdminView = () => {
    document.getElementById('approved').innerHTML = '';

    import('App/Purchasepaybacks').then((m) => {
      let module = m.default;

      new module({
        target: document.getElementById('approved'),
        layout: 'auto',
        props: {
          dateFormat: 'DD.MM.YYYY - HH:mm',
          filter: {
            limit: 10,
            where: {
              and: [
                {
                  completed: 1,
                  status: 'APPROVED',
                },
              ],
            },
          },
          defaultFilter: {
            date: {
              lt: dayjs().format(),
              gt: dayjs().subtract(7, 'day').format(),
            },
          },
          quickFilters: [
            {
              label: 'Last day',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(1, 'day').format(),
                },
              },
            },
            {
              label: 'Last 2 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(2, 'day').format(),
                },
              },
            },
            {
              label: 'Last 3 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(3, 'day').format(),
                },
              },
            },
            {
              label: 'Last 5 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(5, 'day').format(),
                },
              },
            },
            {
              label: 'Last 7 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(7, 'day').format(),
                },
              },
            },
            {
              label: 'Last 30 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(30, 'day').format(),
                },
              },
            },
          ],
          schema: {
            'field-properties': {
              'field-order': [
                'id',
                'date',
                'completed',
                'status',
                'agentDecision',
                'agentFindings',
                'approvedDate',
                ...CRITERIA_STATUS_FIELDS,
                'cashbackType',
                'personalinformation',
                'purchasereceipts',
                'questions',
              ],
              'field-transformation': getStandardFieldTransformations(),
              'auto-generated-fields': ['id'],
              'boolean-fields': [
                'completed',
                'personalinformationOverride',
                'archived',
                'ibanVerified',
                'phoneVerified',
                'addressVerified',
                'dealerOverride',
                'partsOverrride',
                'purchaseDateOverride',
                'storageOverride',
                'switchOverride',
              ],
              'hidden-fields': ['rejectionReason', 'paidDate', 'paidByMbdDate', ...CRITERIA_HIDDEN_FIELDS],
              'readonly-fields': [
                'id',
                'purchasereceipts',
                'purchasereceiptsId',
                'personalinformation',
                'personalinformationId',
                'agentDecision',
                'agentFindings',
                ...ALL_CRITERIA_FIELDS,
              ],
              'textarea-fields': ['agentFindings'],
              'relational-fields': [
                {
                  name: 'personalinformation',
                  editable: true,
                  // columns: ["id", "name", "vorname", "geburtstag", "notizen"],
                },
                {
                  name: 'purchasereceipts',
                  editable: true,
                  // columns: ["id", "name", "vorname", "geburtstag", "notizen"],
                },
              ],
              'dropdown-fields': [
                {
                  name: 'status',
                  default: {
                    label: 'VERIFICATION',
                    value: 'VERIFICATION',
                  },
                  options: [
                    {
                      label: 'INCOMPLETE',
                      value: 'INCOMPLETE',
                    },
                    {
                      label: 'REJECTED',
                      value: 'REJECTED',
                    },
                    {
                      label: 'VERIFICATION',
                      value: 'VERIFICATION',
                    },
                    {
                      label: 'PRE-APPROVED',
                      value: 'PRE-APPROVED',
                    },
                    {
                      label: 'APPROVED',
                      value: 'APPROVED',
                    },
                    {
                      label: 'PRE-PAYMENT',
                      value: 'PRE-PAYMENT',
                    },
                    {
                      label: 'PAID',
                      value: 'PAID',
                    },
                    {
                      label: 'PARKING1',
                      value: 'PARKING1',
                    },
                    {
                      label: 'PARKING2',
                      value: 'PARKING2',
                    },
                    {
                      label: 'PARKING3',
                      value: 'PARKING3',
                    },
                    {
                      label: 'PARKING4',
                      value: 'PARKING4',
                    },
                    {
                      label: 'PARKING5',
                      value: 'PARKING5',
                    },
                  ],
                },
                {
                  name: 'cashbackType',
                  default: {
                    label: 'cashback-basic',
                    value: 'cashback-basic',
                  },
                  options: [
                    {
                      label: 'cashback-basic',
                      value: 'cashback-basic',
                    },
                    {
                      label: 'cashback-full',
                      value: 'cashback-full',
                    },
                  ],
                },
                {
                  name: 'rejectionReason',
                  options: [
                    {
                      label: 'incorrect purchase receipt (invoice)',
                      value: 'incorrect purchase receipt (invoice)',
                    },
                    {
                      label: 'not bought at mercedes dealership',
                      value: 'not bought at mercedes dealership',
                    },
                    {
                      label:
                        'incorrect wheels (QA numbers) and amount of wheels',
                      value:
                        'incorrect wheels (QA numbers) and amount of wheels',
                    },
                    {
                      label: 'not switched / Montage/Wechsel',
                      value: 'not switched / Montage/Wechsel',
                    },
                    {
                      label: 'not stored / keine Einlagerung',
                      value: 'not stored / keine Einlagerung',
                    },
                    {
                      label: 'purchase date not in range',
                      value: 'purchase date not in range',
                    },
                  ],
                },
                ...CRITERIA_DROPDOWN_FIELDS,
              ],
              'json-fields': [
                {
                  field: 'address',
                  template: '${street}, ${zip} ${city}',
                },
              ],
            },
            'custom-bulk-actions': [
              {
                action: 'Incomplete',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'INCOMPLETE',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  return promises;
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'INCOMPLETE',
                      },
                    },
                  });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
              {
                action: 'Verify',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'VERIFICATION',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  debugLog(promises);
                  return promises;
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'VERIFICATION',
                      },
                    },
                  });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
              {
                action: 'Reject',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'REJECTED',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  return promises;
                },
                singleFn: (row) => {
                  rowInstance = row;
                  rejectionReasonModalOpen = true;
                  // return selectedids;
                },
              },
              {
                action: 'Pre-payment',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'PRE-PAYMENT',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  debugLog(promises);
                  return promises;
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'PRE-PAYMENT',
                      },
                    },
                  });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
            ],
          },
        },
      });
    });
  };

  let handleFindingsClick: (e: MouseEvent) => void;
  let aiModalOpen = false;
  let aiLoading = false;
  let aiProcessId: number | null = null;
  let aiDecision: 'APPROVABLE' | 'UNSURE' | 'NOT_APPROVABLE' | null = null;
  let aiFindings = '';
  let aiError = '';

  onMount(() => {
    mountAdminView();
    // listen to the approve event in the global context
    // and update the state of the child component
    window.addEventListener('updateRow', (e) => {
      // e.detail.row is row.id
      eventQueue.enqueue(e.detail);
    });

    handleFindingsClick = (e: MouseEvent) => {
      const chip = (e.target as HTMLElement)?.closest('.agent-findings-chip');
      if (!chip) return;
      const idStr = chip.getAttribute('data-id');
      const findings = chip.getAttribute('data-findings');
      const decision = chip.getAttribute('data-decision');
      if (findings) {
        aiProcessId = idStr ? Number(idStr) : null;
        aiFindings = decodeURIComponent(findings);
        aiDecision = (decision as any) || null;
        aiError = '';
        aiLoading = false;
        aiModalOpen = true;
      }
    };
    document.addEventListener('click', handleFindingsClick);
  });

  onDestroy(() => {
    // remove the event listener
    window.removeEventListener('updateRow', (e) => {
      debugLog(e.detail);
    });
    if (handleFindingsClick) {
      document.removeEventListener('click', handleFindingsClick);
    }
  });

  const updateRow = async (
    detail: { rowId: string; fields: any },
    skipMount = false,
  ) => {
    await fetch(`${URL}/purchasepaybacks/${detail.rowId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(detail.fields),
    });
    if (!skipMount) {
      mountAdminView();
    }
  };

  let progressBar: any;
  let showProgressBar = false;

  const updateProgressBar = (progress: number) => {
    debugLog({ progress });
    progressBar.style.width = `${progress}%`;
  };

  let eventQueue = new EventQueue(
    updateProgressBar,
    updateRow,
    (show: boolean) => {
      showProgressBar = show;
    },
  );

  let rowInstance = null;
  let rejectionReason = '';
  let rejectionReasonModalOpen = false;

  const closeModal = () => (rejectionReasonModalOpen = false);

  const confirmRejection = async () => {
    const event = new CustomEvent('updateRow', {
      detail: {
        rowId: rowInstance.id,
        fields: {
          status: 'REJECTED',
          rejectionReason,
        },
      },
    });
    window.dispatchEvent(event);
    closeModal();
  };
</script>

<RejectionReasonModal
  bind:inputValue={rejectionReason}
  submitFunction={confirmRejection}
  bind:open={rejectionReasonModalOpen}
/>

<AiVerificationModal
  bind:open={aiModalOpen}
  loading={aiLoading}
  processId={aiProcessId}
  decision={aiDecision}
  findings={aiFindings}
  errorMessage={aiError}
/>

<div id="approved" />
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm transition-opacity duration-300 {showProgressBar
    ? 'opacity-100'
    : 'pointer-events-none opacity-0'}"
>
  <div class="w-11/12 max-w-md rounded-lg bg-white p-6 shadow-xl">
    <div class="mb-3">
      <h3 class="text-lg font-medium text-gray-900">Processing...</h3>
      <p class="text-sm text-gray-500">
        Please wait while we update the records.
      </p>
    </div>

    <div class="h-2 w-full overflow-hidden rounded-full bg-gray-200">
      <div
        bind:this={progressBar}
        class="h-full w-0 rounded-full bg-blue-600 transition-all duration-300 ease-out"
      ></div>
    </div>
  </div>
</div>
